import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/miranda-tokens'

import { getStopType, type Stop } from 'core/domain/Stop'
import { getStopInfoArrayFromStops } from 'core/presenters/stopPresenter'
import { getStopTypeLabel } from 'core/presenters/stopTypePresenter'

import { ExtraStopInformation } from './ExtraStopInformation'
import { StopTimelineItem } from './StopTimelineItem'

const ExtraInfoWrapper = styled.div`
  padding-top: ${getToken('spacing-8')};
`

export type StopsTimelineProps = {
  compact?: boolean
  stops: Array<Stop>
}

export function StopsTimeline({ compact = false, stops }: StopsTimelineProps) {
  if (compact && stops.length > 2) {
    const firstStop = stops[0]
    const lastStop = stops[stops.length - 1]

    const stopsInfos = getStopInfoArrayFromStops(stops.slice(1, -1))

    return (
      <>
        <StopTimelineItem stop={firstStop} stopType="pickup" stopLabel="Pickup">
          <ExtraInfoWrapper>
            <ExtraStopInformation stops={stopsInfos} />
          </ExtraInfoWrapper>
        </StopTimelineItem>
        <StopTimelineItem stop={lastStop} stopType="delivery" stopLabel="Delivery" />
      </>
    )
  }

  return (
    <>
      {stops.map((stop, index) => {
        const type = getStopType(index, stops)
        return (
          <StopTimelineItem
            key={`stop-${index}`}
            stopType={type}
            stop={stop}
            stopLabel={getStopTypeLabel(type)}
          />
        )
      })}
    </>
  )
}
